import { useTheme } from '@pixee/design-system'
import { PropsWithChildren } from 'react'
import { useLocation } from 'react-router'
import type { CurrentUserResponse } from '../../utils/api-client/api-schemas.ts'
import { getEnvironmentData } from '../../utils/hooks/get-environment-data.ts'
import { Footer } from '../footer'
import { NavigationBar, NavigationBarPure } from '../navigation-bar'
import * as styles from './with-layout.css.ts'

const SAMPLE_USER: CurrentUserResponse = {
  login: 'johndoe',
  username: 'johndoe',
  avatar_url: '/0-Icon-Trimmed.png',
  roles: [],
}

export const WithLayout = (props: PropsWithChildren) => {
  return (
    <>
      <NavigationBar />
      <div className={styles.siteContainer}>
        <main className={styles.main}>{props.children}</main>
        <Footer />
      </div>
    </>
  )
}

export const WithStubLayout = (props: PropsWithChildren) => {
  const { theme, toggleTheme } = useTheme()
  const { pathname } = useLocation()

  return (
    <>
      <NavigationBarPure
        environmentData={getEnvironmentData()}
        user={SAMPLE_USER}
        isAdmin={false}
        pathname={pathname}
        theme={theme}
        toggleTheme={toggleTheme}
      />
      <div className={styles.siteContainer}>
        <main className={styles.main}>{props.children}</main>
        <Footer />
      </div>
    </>
  )
}
